import React from 'react';
import './index.scss';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { formatPrice, formatTextFloat } from '../../../helpers/Text';
import { formatDataBidAsk } from '../../../helpers/Common';

class IndexInfo extends React.Component {
  state = {
    realtimeData: null,
  };

  componentDidMount() {
    MessageHub.subscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { data } = this.props;
    if (data.organCode !== nextProps.data.organCode) {
      this.setState({
        realtimeData: null,
      });
    }
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
  }

  onReceiveBidAsk = bidAsks => {
    const { data } = this.props;
    const matchData = bidAsks.find(item => item.organCode === data.organCode);
    if (!matchData) {
      return;
    }

    this.setState({
      realtimeData: matchData,
    });
  };

  getBidAskValue = (value, volume, isDerivatives, timeStamp) => {
    const { data } = this.props;
    const bidAskData = isDerivatives ? value : formatPrice(value);
    return (
      formatDataBidAsk(
        bidAskData,
        volume,
        timeStamp,
        isDerivatives,
        data.marketStatus,
        data.comGroupCode,
      ) || formatTextFloat(bidAskData)
    );
  };

  getFinalData = () => {
    const { realtimeData } = this.state;
    const { data } = this.props;

    return {
      ...data,
      ...(realtimeData
        ? {
            Bid: realtimeData.best1Bid,
            Ask: realtimeData.best1Offer,
            Best1BidVolume: realtimeData.best1BidVolume,
            Best1OfferVolume: realtimeData.best1OfferVolume,
          }
        : {}),
    };
  };

  render() {
    const { isDerivatives } = this.props;

    const {
      Bid,
      Ask,
      OpenPrice,
      HighestPrice,
      LowestPrice,
      TradingDate,
      Best1BidVolume,
      Best1OfferVolume,
    } = this.getFinalData();

    return (
      <div className="item-infor mr-3 ml-3">
        <div className="item-infor--first-row">
          <div className="item">
            <div className="main-text">O:</div>
            <div className="sub-text font-weight-bold">
              {`${formatTextFloat(
                isDerivatives ? OpenPrice : formatPrice(OpenPrice),
              )}`}
            </div>
          </div>
          <div className="item">
            <div className="main-text">H:</div>
            <div className="sub-text font-weight-bold">
              {`${formatTextFloat(
                isDerivatives ? HighestPrice : formatPrice(HighestPrice),
              )}`}
            </div>
          </div>
          <div className="item">
            <div className="main-text">L:</div>
            <div className="sub-text font-weight-bold">
              {`${formatTextFloat(
                isDerivatives ? LowestPrice : formatPrice(LowestPrice),
              )}`}
            </div>
          </div>
        </div>
        <div className="item-infor--second-row">
          <div className="item">
            <div className="main-text">BID:</div>
            <div className="sub-text font-weight-bold">
              {this.getBidAskValue(
                Bid,
                Best1BidVolume,
                isDerivatives,
                TradingDate,
              )}
            </div>
          </div>
          <div className="item">
            <div className="main-text">ASK:</div>
            <div className="sub-text font-weight-bold">
              {this.getBidAskValue(
                Ask,
                Best1OfferVolume,
                isDerivatives,
                TradingDate,
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

IndexInfo.defaultProps = {
  data: {
    MatchPrice: 0,
    PriceChange: 0,
    PercentPriceChange: 0,
    ReferencePrice: 0,
    TradingDate: null,
  },
  isDerivatives: false,
};

export default IndexInfo;
